/** The document kinds a person can pick when sending a file, and their words. One home: the upload
 * screen's picker, the batch table and the file card all print a kind, and two lists of kinds is
 * how a kind added to the picker shows up as a raw key in the table beside it. The values are the
 * API's `DocumentKind`; the server validates the enum and answers 422 for one it does not have. */
export const KIND_LABEL: Record<string, string> = {
  electricity_bill: "Electricity bill",
  gas_bill: "Gas bill",
  fuel_invoice: "Fuel invoice",
  refrigerant_log: "Refrigerant log",
  certificate: "Certificate",
  contract: "Contract",
  spreadsheet: "Spreadsheet",
  other: "Other",
};

export function kindLabel(kind: string): string {
  return KIND_LABEL[kind] ?? kind.replace(/_/g, " ");
}
